import React from 'react';
import { useShow, IResourceComponentsProps } from '@refinedev/core';
import { Show, DateField } from '@refinedev/antd';
import { Typography, Tag, Descriptions } from 'antd';

const { Title } = Typography;

export const OfferShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>Offer Details</Title>
      <Descriptions bordered column={2}>
        <Descriptions.Item label="Id">{record?.id}</Descriptions.Item>
        <Descriptions.Item label="Name">{record?.name}</Descriptions.Item>
        <Descriptions.Item label="Type">
          <Tag>{record?.type}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Platform">
          <Tag color="blue">{record?.platform}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <Tag color={record?.isActive ? 'green' : 'red'}>
            {record?.isActive ? 'Active' : 'Inactive'}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Priority">{record?.priority}</Descriptions.Item>
        <Descriptions.Item label="Start Date">
          <DateField value={record?.startDate} />
        </Descriptions.Item>
        <Descriptions.Item label="End Date">
          <DateField value={record?.endDate} />
        </Descriptions.Item>
        <Descriptions.Item label="Created At">
          <DateField value={record?.createdAt} />
        </Descriptions.Item>
        <Descriptions.Item label="Updated At">
          <DateField value={record?.updatedAt} />
        </Descriptions.Item>
      </Descriptions>

      {record?.config && (
        <>
          <Title level={5} style={{ marginTop: 20 }}>
            Configuration
          </Title>
          <pre>{JSON.stringify(record?.config, null, 2)}</pre>
        </>
      )}
    </Show>
  );
};
